import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Getdata } from "../helpers/api.service";
import Breadcrums from "../Components/common/Breadcrums";
import ImageCarousal from "../Components/ImageCarousal";
import dayjs from "dayjs";
import Performance from "../Components/Education/Performance";
import Subjects from "../Components/Education/Subjects";
import Facilities from "../Components/Education/Facilities";
import Projects from "../Components/Education/Projects";
import Streams from "../Components/Education/Streams";
import pdfIcon from "../assets/icons/pdf.svg"
const tabs = [
  { id: "academics", label: "Academics" },
  { id: "performance", label: "Performance" },
  { id: "subjects", label: "Subjects" },
  { id: "facilities", label: "Facilities" },
  { id: "streams", label: "Streams" },
  { id: "projects", label: "Projects" },
];

const Education = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { description } = location.state || {};
  // const { title } = useParams();
  const title = "Education";
  let [academicsdata, setAcademicsData] = useState([]);
  let [loading, setLoading] = useState(false);
  const [images, setImages] = useState([]);
  const [activeTab, setActiveTab] = useState(
    localStorage.getItem("activeTab") || "academics"
  );

  useEffect(() => {
    localStorage.setItem("activeTab", activeTab);
  }, [activeTab]);

  const handleTabClick = (tabId) => {
    setActiveTab(tabId);
    // navigate(`/page/${tabId}`); // example route for each tab
  };

  const fetchData = () => {
    setLoading(true);
    Getdata(
      process.env.REACT_APP_URL +
      `/front/education/facility/fetch/${process.env.REACT_APP_SUBDOMAIN}`
    )
      .then((res) => {
        console.log("News API response:", res);
        // if (res?.data) {
        //   setData(res.data);
        // }
        setImages(res.data.map((item) => item.image[0]));
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching news:", err);
        setLoading(false);
      });
  };

  const fetchacAdemicsData = () => {
    setLoading(true);
    Getdata(
      process.env.REACT_APP_URL +
      `/front/education/academic/fetch/${process.env.REACT_APP_SUBDOMAIN}`
    )
      .then((res) => {
        console.log("fetchacAdemicsData:", res);
        if (res?.data) {
          setAcademicsData(res.data?.academics?.[0]);
        }
        // setImages(res.data.map((item) => item.image[0]));
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching news:", err);
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchData();
    fetchacAdemicsData();
  }, []);

  return (
    <div className="">
      {/* <div className="text-start  max-w-sm md:max-w-lg lg:max-w-3xl xl:max-w-[60rem] 2xl:max-w-6xl mx-auto font-medium my-5">
        <Breadcrums
          pages={[{ title: "Extracurricular", link: " " }, { title: title }]}
        />
      </div> */}
      <ImageCarousal images={images} title={title} />

      <div className="w-full flex flex-wrap gap-3 px-6 sm:mx-auto sm:justify-center max-w-sm md:max-w-lg lg:max-w-3xl xl:max-w-[60rem] 2xl:max-w-6xl py-[30px]">
        {/* Tabs */}
        <div className="w-full flex flex-wrap gap-3 sm:justify-center md:justify-start">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => handleTabClick(tab.id)}
              className={`px-5 py-2 rounded-lg text-sm font-medium transition
            ${activeTab === tab.id
                  ? "bg-secondary_main text-white"
                  : "bg-[#EEF0F2] text-[#7C7C7C] font-normal hover:bg-gray-200"
                }`}
            >
              {tab.label}
            </button>
          ))}
        </div>

        {/* Content area below */}
        <div className="mt-6 w-full sm:text-center">
          {activeTab === "academics" && (
            <div className="mx-auto flex justify-start sm:justify-center">
              <a
                href={academicsdata?.image}
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src={pdfIcon}
                  alt="PDF"
                  className="cursor-pointer mb-2"
                  style={{ width: '60px', height: '60px' }}
                />
                <span className="font-bold">{academicsdata?.image?.split("/")[academicsdata?.image.split("/").length - 1]}</span>
              </a>
            </div>
          )}
          {activeTab === "performance" && <Performance />}
          {activeTab === "subjects" && <Subjects />}
          {activeTab === "facilities" && <Facilities />}
          {activeTab === "streams" && <Streams />}
          {activeTab === "projects" && <Projects />}
        </div>
      </div>


    </div>
  );
};

export default Education;
